import { SET_LANGUAGE } from '../constants/ActionTypes';

export const setLanguage = (language) => ({
  type: SET_LANGUAGE,
  payload: language,
});
